import type { Banner } from '../../../services/ui';

/**
 * Whether the lobby header renders RiveHeader (animated) rather than the plain <picture>.
 *
 * Shared because the banner preloader in preloadLobbyBanner.ts has to reach the same verdict as
 * GenericHeader does: the two paths render *different* image URLs (`desktop`/`mobile` vs
 * `animationBackgroundUrl`/`mobileAnimationBackgroundUrl`), so if the predicate drifts, the
 * preloader warms a URL the page never requests and the real one is fetched cold.
 */
export const lobbyBannerHasAnimation = (
  coinTypeBanner: Banner | null | undefined,
  animationOnlyBanner: Banner | null | undefined,
): boolean =>
  Boolean(
    (coinTypeBanner?.desktopBanner?.animationUrl && coinTypeBanner?.desktopBanner?.animationBackgroundUrl) ||
      animationOnlyBanner?.desktopBanner?.animationUrl,
  );
